/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from "react";

import "./NewRouteDialog.css";
import { Button, Table as BulmaTable } from "react-bulma-components";
import styled from "styled-components";

import { TransitsTableForm } from "components/TransitsTableForm/TransitsTableForm";
import { useUserAddresses } from "hooks/addresses";
import { useCandidateRoutes } from "hooks/candicate_routes";
import { UserAddress } from "models/address";
import { SuggestedPreparedRoute } from "models/suggestedPreparedRoute";
import * as Table from "molecules/Table";

export const EDIT_MODE = {
  PUBLIC_TRANSPORTATION: "PUBLIC_TRANSPORTATION",
  CAR_AND_BICYCLE: "CAR_AND_BICYCLE",
  MANUAL: "MANUAL",
} as const;

export type EditMode = typeof EDIT_MODE[keyof typeof EDIT_MODE];

export interface NewRouteDialogProps {
  isVisible: boolean;
  isCreateInProgress: boolean;
  arrivalId?: number;
  arrivalName?: string;
  createPreparedRoute: (suggestedPreparedRoute: SuggestedPreparedRoute) => void;
  toggleDialog: (
    arrivalId?: number,
    arrivalName?: string,
    departureId?: number,
    departureName?: string
  ) => void;
}

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NewRouteDialog: React.FC<NewRouteDialogProps> = ({
  isVisible,
  isCreateInProgress,
  arrivalId,
  arrivalName,
  createPreparedRoute: _createPreparedRoute,
  toggleDialog: _toggleDialog,
}) => {
  const [routes, setRoutes, setFetchCondition, isCandidateRoutesLoaded] =
    useCandidateRoutes();
  const [editMode, setEditMode] = useState<EditMode | null>(null);
  const [departureId, setDepartureId] = useState<number | null>(null);
  const userAddresses = useUserAddresses();

  const changeEditMode = (mode: EditMode | null) => {
    setEditMode(mode);
    if (mode === EDIT_MODE.MANUAL) {
      if (routes.length !== 1) {
        setRoutes(
          defaultSuggestedPreparedRoutesForManual(
            departureId || undefined,
            undefined,
            arrivalId,
            arrivalName
          )
        );
      }
      if (departureId && arrivalId) {
        setFetchCondition({
          departureId,
          arrivalId,
          mode: "car",
        });
      }
    }
  };

  useEffect(() => {
    if (!editMode || editMode === EDIT_MODE.MANUAL) {
      return;
    }

    if (departureId && arrivalId) {
      setFetchCondition({
        departureId,
        arrivalId,
        mode: editMode === EDIT_MODE.CAR_AND_BICYCLE ? "car" : undefined,
      });
    }
  }, [arrivalId, departureId, editMode, setFetchCondition, userAddresses]);

  const resetState = () => {
    setDepartureId(null);
    changeEditMode(null);
    setFetchCondition(null);
  };

  const toggleDialog = () => {
    resetState();
    _toggleDialog();
  };

  const createPreparedRoute = (x: SuggestedPreparedRoute) => {
    resetState();
    _createPreparedRoute(x);
  };

  const onSelectUserAddress = (x: UserAddress) => {
    setDepartureId(x.id);
  };

  const changeTransportationType = (mode: any) => {
    if (departureId && arrivalId) {
      setFetchCondition({
        departureId,
        arrivalId,
        mode,
      });
    }
  };

  // react-bulma-componentのModalを使うと
  // `Type '{ children: Element; }' has no properties in common with type 'IntrinsicAttributes & ModalProps'.  TS2559`
  // ModalにchildrenっていうPropsが無いってエラーになるので、一旦素のbulmaのままにしている
  return (
    <div
      className={`modal cw-new-route-dialog ${isVisible ? "is-active" : ""}`}
    >
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            通勤経路追加
            {editMode === EDIT_MODE.PUBLIC_TRANSPORTATION &&
              "（公共交通機関を使う）"}
            {editMode === EDIT_MODE.CAR_AND_BICYCLE &&
              "（公共交通機関を使わない）"}
            {editMode === EDIT_MODE.MANUAL && "（手動入力）"}
          </p>
          <button
            type="button"
            className="delete"
            aria-label="close"
            onClick={(_event) => toggleDialog()}
          />
        </header>
        <section className="modal-card-body">
          {!editMode && renderQuestion(changeEditMode)}
          {editMode && (
            <Route
              isCreateInProgress={isCreateInProgress}
              isCandidateRoutesLoaded={isCandidateRoutesLoaded}
              editMode={editMode}
              suggestedPreparedRoutes={routes}
              toggleDialog={toggleDialog}
              createPreparedRoute={createPreparedRoute}
              arrivalName={arrivalName}
              userAddresses={userAddresses}
              onSelectUserAddress={onSelectUserAddress}
              changeTransportationType={changeTransportationType}
            />
          )}
        </section>
        <ModalFooter className="modal-card-foot">
          <Button onClick={() => toggleDialog()}>キャンセル</Button>
          {isCandidateRoutesLoaded && editMode !== EDIT_MODE.MANUAL && (
            <Button onClick={() => changeEditMode(EDIT_MODE.MANUAL)}>
              手動入力
            </Button>
          )}
        </ModalFooter>
      </div>
    </div>
  );
};

const renderQuestion = (changeEditMode: (editMode: EditMode) => void) => (
  <div className="cw-new-route-dialog-question">
    <div className="cw-new-route-dialog-question-action">
      <button
        type="button"
        className="button is-fullwidth cw-new-route-dialog-question-action-button"
        onClick={(_event) => {
          changeEditMode(EDIT_MODE.PUBLIC_TRANSPORTATION);
        }}
      >
        <span>
          <strong>公共交通機関を使う</strong>
          <br />
          （鉄道・バスなどを利用）
          <br />
          <span className="cw-new-route-dialog-question-action-button-icons">
            <span className="icon">
              <i className="fas fa-subway" />
            </span>
            <span className="icon">
              <i className="fas fa-bus" />
            </span>
          </span>
        </span>
      </button>
      <div className="cw-new-route-dialog-question-action-example">
        （例）自宅 ⇒ 駅A ⇒ 駅B ⇒ 通勤先など
      </div>
    </div>
    <div className="cw-new-route-dialog-question-action">
      <button
        type="button"
        className="button is-fullwidth cw-new-route-dialog-question-action-button"
        onClick={(_event) => {
          changeEditMode(EDIT_MODE.CAR_AND_BICYCLE);
        }}
      >
        <span>
          <strong>公共交通機関を使わない</strong>
          <br />
          （徒歩通勤、マイカー・自転車を利用）
          <br />
          <span className="cw-new-route-dialog-question-action-button-icons">
            <span className="icon">
              <i className="fas fa-walking" />
            </span>
            <span className="icon">
              <i className="fas fa-car" />
            </span>
            <span className="icon">
              <i className="fas fa-bicycle" />
            </span>
          </span>
        </span>
      </button>
      <div className="cw-new-route-dialog-question-action-example">
        （例）自宅 ⇒ 通勤先
      </div>
    </div>
  </div>
);

function Route({
  isCreateInProgress,
  isCandidateRoutesLoaded,
  editMode,
  suggestedPreparedRoutes,
  createPreparedRoute,
  arrivalName,
  userAddresses,
  onSelectUserAddress,
  changeTransportationType,
}: {
  isCreateInProgress: boolean;
  isCandidateRoutesLoaded: boolean;
  editMode: EditMode;
  suggestedPreparedRoutes: SuggestedPreparedRoute[];
  toggleDialog: () => void;
  createPreparedRoute: (suggestedPreparedRoute: SuggestedPreparedRoute) => void;
  arrivalName?: string;
  userAddresses: UserAddress[];
  onSelectUserAddress: (userAddress: UserAddress) => void;
  changeTransportationType: (mode: any) => void;
}): React.ReactElement | null {
  return (
    <>
      <BulmaTable>
        <tbody>
          <tr>
            <Table.Th>出発地</Table.Th>
            <Table.Td>
              <UserAddressesSelect
                userAddresses={userAddresses}
                onSelectUserAddress={onSelectUserAddress}
              />
            </Table.Td>
          </tr>
          {/* {editMode !== EDIT_MODE.MANUAL && (
              <tr>
              <Table.Th>最寄り駅</Table.Th>
              <Table.Td>
              {nearestStationName}
              <Button disabled onClick={() => toggleDialog()}>
              最寄駅設定
              </Button>
              </Table.Td>
              </tr>
              )} */}
          <tr>
            <Table.Th>勤務地</Table.Th>
            <Table.Td>{arrivalName}</Table.Td>
          </tr>
        </tbody>
      </BulmaTable>

      {isCandidateRoutesLoaded && suggestedPreparedRoutes.length === 0 && (
        <div>候補がみつかりませんでした</div>
      )}
      {isCandidateRoutesLoaded &&
        suggestedPreparedRoutes.map((suggestedPreparedRoute, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index}>
            <TransitsTableForm
              isCreateInProgress={isCreateInProgress}
              suggestedPreparedRouteIndex={index}
              suggestedPreparedRoute={suggestedPreparedRoute}
              editMode={editMode}
              createPreparedRoute={createPreparedRoute}
              changeTransportationType={changeTransportationType}
            />
          </div>
        ))}
    </>
  );
}

const defaultSuggestedPreparedRoutesForManual = (
  departureId?: number,
  departureName?: string,
  arrivalId?: number,
  arrivalName?: string
) => [
  {
    arrivalId: arrivalId!,
    arrivalName,
    departureId: departureId!,
    departureName,
    totalDistance: 0,
    totalFare: 0,
    totalTime: 0,
    type: "",
    typeName: "",
    suggestedPreparedRouteDetails: [
      {
        arrivalId: arrivalId!,
        arrivalName: arrivalName!,
        departureId: departureId!,
        departureName: departureName!,
        distance: 0,
        fare: 0,
        lineId: "",
        lineName: "",
        orderNo: 0,
        time: 0,
        transportationType: 3,
        transportationTypeName: "マイカー",
        useCommuterPass: false,
        initialUseCommuterPass: false,
      },
    ],
  },
];

function UserAddressesSelect({
  userAddresses,
  onSelectUserAddress,
}: {
  userAddresses: UserAddress[];
  onSelectUserAddress: (id: UserAddress) => void;
}): React.ReactElement | null {
  const [selectedId, setSelectedId] = useState(
    userAddresses.length > 0 ? userAddresses[0].id : undefined
  );

  useEffect(() => {
    if (selectedId) {
      onSelectUserAddress(userAddresses.find((x) => x.id === selectedId)!);
    }
  }, [selectedId, onSelectUserAddress, userAddresses]);

  return (
    <div className="select">
      <select
        value={selectedId}
        onChange={(event) => {
          const val = event.target.selectedOptions[0].value;
          if (val) {
            setSelectedId(parseInt(val, 10));
          }
        }}
      >
        {userAddresses.map((x) => (
          <option key={x.id} value={x.id}>
            {x.address}
            {` (ID: ${x.id}, 有効期間: ${x.startDate.format(
              "YYYY/MM/DD"
            )} - ${x.endDate.format("YYYY/MM/DD")})`}
          </option>
        ))}
      </select>
    </div>
  );
}
/* eslint-enable */
